import cn from "classnames";
import React from "react";
import { getDataTestId } from "../../../../utils/getDataTestId";
import {
  detachLayoutProps,
  WSElement,
  WSElementProps
} from "../../WSElement/WSElement.component";
import styles from "./WSSwitchInput.module.scss";

export interface WSSwitchInputProps extends WSElementProps {
  name: string;
  value: boolean;
}

export const WSSwitchInput = React.forwardRef<
  HTMLInputElement,
  WSSwitchInputProps
>((props, ref) => {
  const {
    className = "",
    layoutProps,
    systemProps,
    name,
    value,
    onChange,
    ...inputProps
  } = detachLayoutProps(props);

  const testIdBase = getDataTestId("switchInput", name);

  return (
    <WSElement
      {...systemProps}
      className={cn(styles.switch, className, {
        [styles.onState]: value
      })}
      {...layoutProps}
      as="label"
      data-testid={testIdBase}
    >
      <input
        ref={ref}
        type="checkbox"
        name={name}
        checked={value}
        onChange={() => {
          onChange?.(!value as any);
        }}
        className={styles.input}
        data-testid={`${testIdBase}Input`}
        {...inputProps}
      />
      <i className={styles.switcher} />
    </WSElement>
  );
});
